import { forwardRef } from "react";
import { lineToString, pointsToLine } from "../../domain/lineDomain";
import { useEffect } from "react";
import { MathJax } from "better-react-mathjax";

export const Legend = forwardRef(function Legend({ datas, legendState, xLabel,yLabel }, ref) {
  const style = {
    position: "absolute",
    background: "rgba(230,230,230,0.6)",
    padding: 10,
    border: "3px double black",
    left: Number(legendState.x) + 80,
    top: Number(legendState.y),
    fontSize:legendState.fontSize
  };

  return (
    <div>
      <div ref={ref} data-legend style={style}>
        {datas.map((data) => {
        const line = pointsToLine(data.points,xLabel.isLog,yLabel.isLog)  
        return(
          <>
          <div
            key={data.name}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
            }}
          >
            <div
              style={{
                width: 12,
                height: 12,
                borderRadius: "50%",
                background: "#" + data.color.padEnd(6, "0"),
              }}
            />
            <span>{data.name}</span>
          </div>
          {data.isLine && <span 
          style={{
                fontSize:legendState.fontSize/1.5
              }}>
                <MathJax inline dynamic>{lineToString(line,xLabel,yLabel)}</MathJax>
                </span>}
          </>
        )})}
      </div>
    </div>
  );
});